import React from 'react';

interface ImageCoverProps {
  alt: string;
  className?: string;
  objectFit?: 'fill' | 'contain' | 'cover' | 'scale-down' | 'none';
  src: string;
  aspectRatio?: string;
  maxHeight?: string;
}

const ImageCover = ({
  alt,
  objectFit = 'cover',
  src,
  aspectRatio = '1',
  maxHeight = '100%',
  ...props
}: ImageCoverProps): JSX.Element => (
  <img
    src={src}
    alt={alt}
    style={{
      maxWidth: '100%',
      maxHeight,
      objectFit,
      aspectRatio,
    }}
    {...props}
  />
);

export default ImageCover;
